import { Controller } from "@hotwired/stimulus"

// Submit stays enabled in HTML so no-JS users can submit when native validation passes
// (`required` checkboxes). After connect we mirror that rule by disabling until checked.
//
// By default every checkbox target must be checked. Set requireAll=false to enable
// submit when at least one checkbox is checked (e.g. "request these fields").
export default class extends Controller {
  static targets = ["checkbox", "submit"]
  static values = { requireAll: { type: Boolean, default: true } }

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled =
      this.checkboxTargets.length > 0 &&
      (this.requireAllValue
        ? this.checkboxTargets.every((el) => el.checked)
        : this.checkboxTargets.some((el) => el.checked))
    this.submitTargets.forEach((el) => {
      el.disabled = !enabled
    })
  }
}
